import { CallOutError } from "components/CallOutError/CallOutError";
import { useProjectDataContext } from "pages/project/ProjectDataProvider";
import { useProjectPermissionStore } from "pages/project/ProjectPermissionProvider";
import { useUserContext } from "providers/UserProvider/UserProvider";
import { ReactNode } from "react";

type ProjectAccessCalloutProps = {
  children: ReactNode;
};

export const ProjectAccessCallout = ({
  children,
}: ProjectAccessCalloutProps) => {
  const hasViewPermission = useProjectPermissionStore(
    (s) => s.permissions["view"],
  );
  const { project } = useProjectDataContext();

  const userTenants = useUserContext((s) => s.tenants);

  const isOrgAdmin =
    userTenants.find(({ id }) => id === project.tenantId)?.role.key === "admin";

  if (!hasViewPermission && !isOrgAdmin) {
    return (
      <CallOutError
        message="The project you are trying to access does not exist or you do not have
        access to it."
        suppressContactSupport
      />
    );
  }

  return <>{children}</>;
};
